import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpInterceptor } from "@angular/common/http";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { catchError, filter, switchMap, take } from "rxjs/operators";
import { Router } from "@angular/router";
import { Inject, Injectable, NgZone } from "@angular/core";
import { ExtendedAuthenticationService } from '../services/extended-authentication.service';
import { LoadingAnimationService } from "@/core/services/loading-animation.service";

@Injectable({
    providedIn: 'root'
})
export class TokenAuthenticationHttpInterceptor implements HttpInterceptor {

    protected isRefreshing = false;
    protected refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(protected authenticationService: ExtendedAuthenticationService, 
        protected router: Router, 
        protected authService: ExtendedAuthenticationService,
        protected ngZone: NgZone,
        protected loadingAnimationService: LoadingAnimationService) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401 && error.headers.get("WWW-Authenticate")?.includes("Bearer error=\"token_expired\"")) {
                    return this.handle401Error(req, next);
                }
                
                return throwError(error);
            })
        );
    }
 
    
    protected handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authenticationService.refreshAccessToken().pipe(
                switchMap(response => {
                    this.isRefreshing = false;
                    if (response) {
                        this.refreshTokenSubject.next(response);
                        return next.handle(request);
                    }

                    return next.handle(request).pipe(
                        catchError((err: any)=>{
                            console.log(err);

                            if (err.status === 401 || err.status === 403) {
                                this.Logout()
                                return of(err.message);
                            }
                            // handle your auth error or rethrow
                            return throwError(err);
                        })
                    );
                }));
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(response => next.handle(request)));
        }
    }

    public Logout(){
        this.authenticationService.logout().subscribe(() => {
            this.rerouteToRoot();
        });
    }

    private rerouteToRoot(){
        this.ngZone.run(() => {
            this.loadingAnimationService.hide();
            this.loadingAnimationService.onTeardown();
            this.router.navigateByUrl("/")
        });
    }
}